module.exports = __webpack_public_path__ + "img/dropdown_arrow_green.6e4985b9.svg";